import { useSelector } from 'react-redux';
import { embedView, ROUTE_POSITION_PATH } from 'routes';

const usePositionBreadcrumb = (path) => {
  const literals = useSelector(state => state.i18n.literals.myInvestments);

  const {
    PORTFOLIO,
    ANALYSIS,
    OPPORTUNITIES,
    EDIT_INVESTOR,
  } = ROUTE_POSITION_PATH;

  const mapLiterals = {
    [PORTFOLIO]: {
      name: literals.portfolio,
      path: PORTFOLIO,
    },
    [ANALYSIS]: {
      name: literals.analysis,
      path: ANALYSIS,
    },
    [OPPORTUNITIES]: {
      name: literals.opportunities,
      path: OPPORTUNITIES,
    },
    [EDIT_INVESTOR]: {
      name: literals.profile,
      path: EDIT_INVESTOR,
    },
  };

  return {
    routes: [
      { name: literals.title },
      { name: mapLiterals[path].name },
    ],
    nextRoutes: Object.keys(mapLiterals).map(key => ({
      name: mapLiterals[key].name,
      path: embedView(mapLiterals[key].path),
      actual: key === path,
    })),
  };
};

export default usePositionBreadcrumb;
